export default {
  title: 'Wie Estimator24 funktioniert',
  steps: [
    {
      title: 'Marktanalyse',
      description: 'Das Modell analysiert die Preise und Trends in der Stadt'
    },
    {
      title: 'Bewertung',
      description: 'Sie erhalten eine automatische Wertermittlung'
    },
    {
      title: 'Analyse',
      description: 'Zusätzlich sehen Sie Vergleichsobjekte, Diagramme und Empfehlungen'
    },
    {
      title: 'Entscheidung',
      description: 'Auf Grundlage der Daten treffen Sie eine Investitions- oder persönliche Entscheidung'
    }
  ]
}
